// extracted by mini-css-extract-plugin
export var addToBasketWrapper = "shopItem-module--add-to-basket-wrapper--WlfVD";
export var container = "shopItem-module--container--emPJ+";
export var detailsContainer = "shopItem-module--details-container--KGpAO";
export var infoBanner = "shopItem-module--info-banner--8qwAo";
export var price = "shopItem-module--price--kWqd0";